import React from "react";

import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import { useRouteMatch } from "react-router-dom";

import RbGrid from "components/RbGrid";
import RbScrollView from "components/RbScrollView";
import FieldsProvider from "fields/components/FieldsProvider";
import useFields from "fields/hooks/useFields";
import useSnackbar from "hooks/useSnackbar";
import { convertValuesToInput } from "utils/graphqlUtils";

function BaseForm(props) {
  const { children, row, createPromise, updatePromise, title } = props;

  const { path } = useRouteMatch();
  const match = useRouteMatch(`${path}/:idParam`);
  const { fields, handleChange, setValues, reset, valid } = useFields();
  const { openSnackbar } = useSnackbar();

  const idParam = match?.params?.idParam;
  const newer = !idParam || idParam === "new";

  const handleSubmit = (event) => {
    event.preventDefault();
    const variables = { input: convertValuesToInput(fields.values) };
    if (idParam && idParam !== "new") {
      updatePromise({ variables }).then(() => {
        openSnackbar({ message: "Updated successfully." });
      });
    } else {
      createPromise({ variables }).then(() => {
        openSnackbar({ message: "Created successfully." });
        reset();
      });
    }
  };

  React.useEffect(() => {
    if (row) {
      setValues(row);
    } else {
      reset();
    }
  }, [setValues, reset, row]);

  return (
    <RbScrollView p={{ xs: 4, md: 8 }}>
      <Hidden smDown>
        <Typography variant="h6" component="h2" paragraph>
          {newer ? `New ${title}` : `Edit ${title}`}
        </Typography>
      </Hidden>
      <FieldsProvider fields={fields} onChange={handleChange}>
        <form noValidate onSubmit={handleSubmit}>
          <RbGrid container columnGap={5} rowGap={5} mt={{ md: 7 }}>
            {children}
            <RbGrid item xs={12}>
              <Button
                variant="contained"
                type="submit"
                color="primary"
                disabled={!valid}
              >
                SAVE
              </Button>
            </RbGrid>
          </RbGrid>
        </form>
      </FieldsProvider>
    </RbScrollView>
  );
}

BaseForm.propTypes = {
  children: PropTypes.node,
  createPromise: PropTypes.func.isRequired,
  row: PropTypes.object,
  updatePromise: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

BaseForm.defaultProps = {
  children: null,
  row: undefined,
};

export default React.memo(BaseForm);
